<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <router-view></router-view>
    </q-page-container>
  </q-layout>
</template>
<script setup>
</script>

<style lang="scss">
.app-notify.q-notification {
  min-width: 320px;
  border-radius: 12px;
  padding: 0.7rem 1rem;
  box-shadow: 0 8px 24px rgba(31, 24, 63, 0.18);
  color: #ffffff;
  background: linear-gradient(135deg, #312a63 0%, #362f78 55%, #402a6e 100%);

  .q-notification__message {
    font-weight: 500;
    font-size: 0.9rem;
  }

  .q-notification__caption {
    opacity: 0.85;
  }

  .q-notification__icon {
    font-size: 1.4rem;
  }

  .q-notification__progress {
    background: rgba(255, 255, 255, 0.35);
  }
}

.app-notify-positive.q-notification {
  background: linear-gradient(135deg, #1b7a4d 0%, #1f9d5f 100%);
}

.app-notify-negative.q-notification {
  background: linear-gradient(135deg, #8f1d2c 0%, #b3243a 100%);
}

.app-notify-warning.q-notification {
  background: linear-gradient(135deg, #a8681b 0%, #c98420 100%);
  color: #ffffff;
}

.app-notify-info.q-notification {
  background: linear-gradient(135deg, #1d4e89 0%, #2464b4 100%);
}
</style>
